export const COUPONS = {
  'discount_20_usd_off_onetime': 20,
  'discount_30_usd_off_onetime': 30,
}